import isEmpty from 'lodash/isEmpty'
import { parse } from 'query-string'

import { MODAL_NAMES } from '@config/constants'
import { removeEmptyValuesInObject } from '@core/helpers'

import translations from '../CustomizationFunnel.translations'

export const mapOption = (option) => {
  return {
    ...option,
    link: !isEmpty(option.link)
      ? { ...option.link, hash: { ...option.link.hash, scroll: false } }
      : null,
  }
}

/**
 * This function is here to map the response of existing endpoints (pickers, best_offers) to
 * something easily usable by the Customization Funnel.
 *
 * We chose to reuse existing endpoints over a new dedicated one to gain some time developing the
 * MVP that will be A/B tested on smartphones only. This is not meant to be scaled to any other category
 * without a new endpoint to be created.
 */
export const createCustomizationFunnelData = (grade, pickers, $route) => {
  const pickersGrade = pickers.find(({ id }) => id === 'grades')
  const pickersStorage = pickers.find(({ id }) => id === 'storage')
  const pickersColor = pickers.find(({ id }) => id === 'color')
  const pickersSim = pickers.find(({ id }) => id === 'dual_sim')
  const hasNewBattery = grade.newBattery.status === 'available'
  const { offerType } = parse($route.hash)
  const isNewBatterySelected = offerType === grade.newBattery.offerType

  return [
    {
      id: 'grade',
      title: translations.titleStepGrade,
      titleEmphasis: translations.titleEmphasisStepGrade,
      trackingId: pickersGrade.trackingId,
      options: pickersGrade.items.map(mapOption),
      autoScrollOnSelection: false,
    },
    hasNewBattery
      ? {
          id: 'battery',
          desktopIllustration: '/img/product/funnel/step-battery.svg',
          title: translations.titleStepBattery,
          titleEmphasis: translations.titleEmphasisStepBattery,
          trackingId: 'battery_picker',
          options: [
            {
              label: translations.newBatteryOptionNo,
              trackingValue: 'default_battery',
              available: true,
              selected: !isNewBatterySelected,
              link: {
                type: 'internal',
                ...$route,
                hash: removeEmptyValuesInObject({
                  ...parse($route.hash),
                  offerType: undefined,
                }),
              },
            },
            {
              label: translations.newBatteryOptionYes,
              trackingValue: 'new_battery',
              available: true,
              selected: isNewBatterySelected,
              link: {
                type: 'internal',
                ...$route,
                hash: {
                  ...parse($route.hash),
                  offerType: grade.newBattery.offerType,
                },
              },
            },
          ],
          guidance: {
            label: translations.helpCardBattery,
            illustration: '/img/product/funnel/step-battery.svg',
            modalName: MODAL_NAMES.PRODUCT.NEW_BATTERY,
          },
          autoScrollOnSelection: true,
        }
      : null,
    {
      id: 'storage',
      desktopIllustration: '/img/product/funnel/step-storage.svg',
      title: translations.titleStepStorage,
      titleEmphasis: translations.titleEmphasisStepStorage,
      trackingId: pickersStorage.trackingId,
      options: pickersStorage.items.map(mapOption),
      autoScrollOnSelection: true,
    },
    pickersSim
      ? {
          id: 'sim',
          title: translations.titleStepSim,
          titleEmphasis: translations.titleEmphasisStepSim,
          trackingId: pickersSim.trackingId,
          options: pickersSim.items.map(mapOption),
          autoScrollOnSelection: true,
        }
      : null,
    {
      id: 'color',
      title: translations.titleStepColor,
      titleEmphasis: translations.titleEmphasisStepColor,
      columns: 2,
      trackingId: pickersColor.trackingId,
      options: pickersColor.items.map(mapOption),
      autoScrollOnSelection: false,
    },
  ].filter(Boolean)
}
